
<!-- ********************WEB-VIEW ******************** -->

<div class="fluid_container web-view spotlight-background"  fxFlex fxHide.xs fxHide.sm   fxHide.lt-md fxFlex.md  >

    <div fxLayout="column" fxLayoutAlign=" center"  class="header">

        <div class="cinejoy_title">cinejoy</div>
        <div  class="upcoming_web_cart" *ngIf="agilePurchaseEnabled">
            <app-shopping-cart ></app-shopping-cart>
        </div>
    </div>

    <div class="content" >
       <div >
        <div fxFlex class="heading" style="overflow: visible;">
            <div  fxLayout="row" class="premierecentered_up">UPCOMING SPOTLIGHTS</div>

            <div>
                <hr class="premierecentered_hl"/>
            </div>
        </div>
        <div class="upcoming-class" fxFlex="45" fxflex.lg="45" fxFlex.gt-lg="42" fxLayout="row wrap" fxLayoutGap="12px grid"  >
            <div fxFlex="100" fxFlex.gt-lg="73" *ngFor="let premiere of premierelist" fxLayoutAlign="end" style="margin-right: 20px;"  >
                <app-upcoming-card  fxLayoutAlign="end start"  [premiere]="premiere"></app-upcoming-card>

            </div>
        </div>
        </div>

        <div class="spotlight_buttons_initial">

            <a routerlinkactive="active" href="/cinejoy/premiere/lineup" >
                <button  class="moreSpotlights_button">More Spotlights</button>
            </a>
        </div>


    </div>

 </div>






<!-- ********************MOBILE-VIEW ENDED******************** -->


<!-- ********************MOBILE-VIEW ******************** -->




<div class="mobile-view spotlight-background"
                                fxHide.lg
                                fxHide.md
                                fxHide.lt
                                fxFlex.lt-md
                                fxShow.xs
                                fxHide.gt-lg
                                >
    <div  class="mobile_cart" *ngIf="agilePurchaseEnabled">
        <app-shopping-cart ></app-shopping-cart>
    </div>

    <div class="header_mobile">
        <div class="premierecentered_mobile_up">UPCOMING SPOTLIGHTS </div>
        <div>
            <hr class="premierecentered_mobile_hl"/>
        </div>



    </div>

    <div class="content_mobile"  >

        <div fxFlex="100%"  class="fxlineup" fxLayout="column grid" fxFlex.lt-md fxLayoutGap="15px">

            <div *ngFor="let premiere of premierelist">

                <app-upcoming-card [premiere]="premiere"></app-upcoming-card>

            </div>

        </div>

    </div>

    <div class="mobile_spotlight_buttons_initial">

        <a routerlinkactive="active" ng-reflect-router-link-active="active" ng-reflect-router-link="lineup" href="/cinejoy/premiere/lineup" >
            <button  class="mobile_moreSpotlights_button">More Spotlights</button>
        </a>
    </div>

</div>
